





























































































































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import {
    InsertKnowledge,
    UpdateKnowledge
} from "@/api/pdOutPatient/pdEducation/pdKnowledge";
import PdEducationPlay from "./pdPreviousEducationPlay.vue";
import fileShow from "./fileShow.vue";
@Component({
    components: {
        PdEducationPlay,fileShow
    }
})
export default class PdKnowledgeAdd extends AbpBase {
    @Prop() pdKnowledge: any;
    @Prop({ type: Boolean, default: false }) value: boolean;
    loadingStatus: boolean = false;
    showEducationPlay: boolean = false;
    knowledge: any = {};
    knowledgeGroup: any[] = [];
    file: any = {};
    baseUrl: string;
    uploadUrl: string;
    Url = XMLHTTP_BASEURL;
    format=['jpg','jpeg','png'];
    rules = {
        name: [
            {
                required: true,
                type: "string",
                message: "宣教名称不能为空",
                trigger: "change"
            }
        ],
        group: [
            {
                required: true,
                type: "number",
                message: "宣教类型不能为空",
                trigger: "change"
            }
        ]
    };
    headers = {
        Authorization: `Bearer ${window.abp.auth.getToken()}`,
        "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
    };
    fileList:any=[];
/*     created() { */
/*         this.baseUrl = `http://${location.hostname}:${SERVER_PORT}`;
        this.uploadUrl = `${this.baseUrl}/api/services/app/PDEducation/KnowledgeUpload`; */
/*     } */

/*     @Watch("pdKnowledge", { immediate: false, deep: true }) */
    created() {
        this.initDic();
        this.onknowledgeChanged();
    }
    onknowledgeChanged() {
        this.file = {};
        if (this.pdKnowledge) {
            var newObj = Object.assign({}, this.pdKnowledge);
            this.knowledge = newObj;
            this.fileList = newObj.fileList;
        }
    }

/*     resetForm() {
        this.$refs["form"].resetFields();
    } */

    initDic() {
        GetListByCode({ input: "PD_Knowledge_Group" }).then(res => {
            this.knowledgeGroup = res;
        });
    }
    // handleUpload(file) {
    //     this.file = file;
    //     return false;
    // }

    // async uploadSuccess(res: any, file: any) {
    //     this.knowledge.url = `/${res.result.objects.imageAddress}`;
    //     this.knowledge.fileName = this.file.name;
    //     await this.SaveKnowledge();
    // }

    async submitFrom() {
    //      let validResult = false;
    //      this.$refs["form"].validate(valid => {
    //          if (valid) {
    //              validResult = true;
    //          }
    //      });
    //      if (
    //          this.file.name != undefined &&
    //          this.file.name != null &&
    //          this.file.name != "" &&
    //          validResult &&
    //          !this.knowledge.isUrl
    //      ) {
    //         await this.$refs["upload"].post(this.file);
    //      } else {
              await this.SaveKnowledge();
    //      }
    //      return false;
    }

    CancelFile() {
        this.knowledge.url = null;
        this.knowledge.fileName = null;
        this.knowledge.isUrl = false;
        this.file = {};
    }
    async SaveKnowledge() {
        let validResult = false;
        this.knowledge.fileList = this.fileList;
        this.$refs["form"].validate(valid => {
            if (valid) {
                validResult = true;
            }
        });
        if (validResult) {
            if (this.knowledge.id == 0) {
                await InsertKnowledge(this.knowledge);
            } else {
                await UpdateKnowledge(this.knowledge);
            }
            this.$emit("input", false);
            this.$emit("on-success");
        }
    }
    FilePlay() {
        this.showEducationPlay = true;
    }
/*     constructor() {
        super();
        this.initDic();
    } */
    handleRemove (file:string) {
      this.fileList.splice(this.fileList.indexOf(file), 1);
    }
    handleFormatError(file: any) {
        var warnStr =  this.format.join(',')
        this.$Message.warning("请选择"+warnStr+"格式文件！");
    }
    handleMaxSize(file: any) {
        this.$Message.warning("请选择小于200M文件！");
    }
    handleSignSuccess(res: any, file: any) {
        let url = res.result.objects.imageAddress;
        let name = res.result.objects.fileName;
        this.fileList.push({fileName:name,fileUrl:url});
    }
    showUpload=true;
    changeType(){
        this.showUpload = false;
        this.fileList=[];
        if(this.knowledge.type=="图片"){
            this.format=['jpg','jpeg','png'];
        }
        else if(this.knowledge.type=="视频")
        {
             this.format=['mp4'];
        }
        else if(this.knowledge.type=="pdf")
        {
            this.format=['pdf'];
        }else{
             this.format=[];
        }
        this.showUpload=true;
    }
    viewShow=false;
    viewData:any={};
    handleView(item:any) {
        let viewList:any=[];
        viewList.push(item);
        this.viewData={
            fileType:this.knowledge.type,
            fileList:viewList
        }
        this.viewShow = true;
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
        this.$emit("input", value);
        }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdKnowledge/pdKnowledgeAdd.vue